import { Image, Skeleton } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

type Props = {
  height?: string;
  maxHeightImage?: string;
  heightImage?: string;
  urlImage: string;
  classNameSkeleton?: string;
  classNameImage?: string;
  fit?: React.CSSProperties['objectFit'];
  width?: string;
  fallbackImageSrc?: string;
  /** Если задано, высота блока считается от ширины через CSS aspect-ratio, а height/maxHeightImage игнорируются */
  aspectRatio?: number;
};

const ImageWithSkeleton: React.FC<Props> = ({
  height,
  maxHeightImage,
  heightImage = '100%',
  urlImage,
  classNameSkeleton,
  classNameImage,
  fit,
  width,
  fallbackImageSrc,
  aspectRatio,
}) => {
  const [isImageLoading, setIsImageLoading] = React.useState<boolean>(true);
  const [imageSrc, setImageSrc] = React.useState<string>(urlImage);

  const handleLoadImage = React.useCallback(() => {
    setIsImageLoading(false);
  }, []);

  const handleImageError = React.useCallback(() => {
    setIsImageLoading(false);
    if (fallbackImageSrc && imageSrc !== fallbackImageSrc) {
      setImageSrc(fallbackImageSrc);
    }
  }, [fallbackImageSrc, imageSrc]);

  return (
    <Skeleton
      className={classNameSkeleton}
      visible={isImageLoading}
      h={aspectRatio ? undefined : height}
      w={width || '100%'}
      style={aspectRatio ? { aspectRatio } : undefined}
      radius="md"
      bg={isImageLoading ? 'gray.2' : 'transparent'}
    >
      <Image
        src={imageSrc}
        fit={fit}
        className={classNameImage}
        mah={aspectRatio ? undefined : maxHeightImage}
        h={aspectRatio ? '100%' : heightImage}
        onLoad={handleLoadImage}
        onError={handleImageError}
      />
    </Skeleton>
  );
};

export default observer(ImageWithSkeleton);
